import { render, staticRenderFns } from "./registrationname.vue?vue&type=template&id=da5ff43a&scoped=true&"
import script from "./registrationname.vue?vue&type=script&lang=js&"
export * from "./registrationname.vue?vue&type=script&lang=js&"
import style0 from "./registrationname.vue?vue&type=style&index=0&id=da5ff43a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5ff43a",
  null
  
)

export default component.exports